import { Button } from "@swivl-mono/ui";
import { useEffect } from "react";

import { NavBar } from "../../../Models/NavBar/NavBar.Model";
import { useSwivlNavigate } from "../../../Models/NavBar/useSwivlNavigate";

export function WhatsNewView() {
  const navigate = useSwivlNavigate();

  useEffect(() => {
    NavBar.set(null, <NavBar.Component.Logo />);
  }, []);

  return (
    <div className="flex h-full flex-col items-center justify-center">
      <div className="flex max-w-[400px] flex-col justify-center gap-4 rounded-md bg-white p-4 text-left">
        <h1 className="font-bold">Welcome to the new swivl 🎉</h1>
        <div className="text-sm">
          <p>Here are some highlights:</p>
          <ul className="list-disc pl-5">
            <li>
              <span className="font-bold">Conversations</span> now includes our voice channel and a new right panel with more tenant information and
              inventory lookup.
            </li>
            <li>
              <span className="font-bold">MyStorage</span> and <span className="font-bold">Store finder</span> have been combined into a new section
              called <span className="font-bold">Property Manager</span>.
            </li>
            <li>
              For a full list of changes, please refer to{" "}
              <a className="text-orange-500" target="_blank" href="https://learn.tryswivl.com/">
                learn.tryswivl.com
              </a>
            </li>
          </ul>
        </div>
        <span className="text-sm">Check out a quick Property Manager Overview video below:</span>
        <div className="flex flex-col items-center gap-4">
          <a
            className="transition-colors duration-200 ease-in-out hover:outline-orange-500"
            href="https://www.youtube.com/watch?v=zKfBli-9cwc"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              alt="Whats New Video Thumbnail"
              width="368"
              height="206"
              src="https://swivl-cdn.s3-us-west-1.amazonaws.com/studio/whats-new-video-thumbnail.png"
            />
          </a>
          <Button
            onClick={() => {
              navigate("/dashboard");
            }}
          >
            Let's go!
          </Button>
        </div>
      </div>
    </div>
  );
}
